import axiosClient from "src/features/axios/client";
import { AgreementFormValues } from "../routes/LegalAgreementsPage";
import { LegalAgreement } from "../types/legal.types";

class LegalService {
  async acceptAgreements(data: AgreementFormValues): Promise<LegalAgreement> {
    return axiosClient.post("api/legal/accept/", data).then((res) => res.data);
  }
}

const legalService = new LegalService();

export default legalService;
